import { render, staticRenderFns } from "./AgreementDialog.vue?vue&type=template&id=2a6b686c"
import script from "./AgreementDialog.vue?vue&type=script&lang=ts"
export * from "./AgreementDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports